import { Button, Grid2, GridSize } from "@mui/material";
type GridSizes = {
	lg?: GridSize;
	md?: GridSize;
	sm?: GridSize;
	xs?: GridSize;
};
type Props = {
	label: string;
	showCreateModal: boolean;
	setShowCreateModal: (showCreateModal: boolean) => void;
	sizes?: GridSizes;
};

export const FooterButton = ({
	label,
	showCreateModal,
	setShowCreateModal,
	sizes = { lg: 2, md: 2, sm: 6, xs: 6 },
}: Props) => {
	return (
		<Grid2 container justifyContent="flex-end">
			<Grid2
				size={{
					xs: sizes.xs,
					sm: sizes.sm,
					md: sizes.md,
					lg: sizes.lg,
					xl: sizes.lg,
				}}
				sx={{
					display: "flex",
					justifyContent: "flex-end",
				}}
			>
				<Button
					variant="contained"
					color="primary"
					fullWidth
					onClick={() => setShowCreateModal(!showCreateModal)}
				>
					NEW {label}
				</Button>
			</Grid2>
		</Grid2>
	);
};
